

























































































































import { Component, Vue } from 'vue-property-decorator';
import { IRules } from '@/components/UI/Form/ValidationModule';
import { validateRequired } from '@/components/UI/Form/Validations';
import ValueConfirmation from '@/components/ValueConfirmation.vue';

@Component({
  components: {
    ValueConfirmation,
  },
})
export default class ValueConfirmationExamples extends Vue {
  private val1 = '';
  private val2 = '';
  private val3 = 'thing';
  private val4 = 'thing';

  private val1Confirmed = false;
  private val2Confirmed = true;
  private val3Confirmed = true;
  private val4Confirmed = true;

  private validForm1 = true;

  private rules: IRules = {
    val2: [ { validation: validateRequired(), message: 'Moras da ga imas' } ],
    confirmation: [ { validation: v => v.dataValue !== 'asd', message: 'Ne radi' } ],
  }
}
